import React from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import './pay-invoice.css';
import { FaFastBackward, FaDownload } from 'react-icons/fa';
import { SlPrinter } from 'react-icons/sl';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';

export default function PayinVoice() {
  const navigate = useNavigate();

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    doc.text("This is your PDF content", 10, 10);
    doc.save('invoice.pdf');
  };

  const handleGoBack = () => {
    navigate('/payroll-report');
  };

  return (
    <Container fluid className="pay-invoice-containerrr">
      <Row className="justify-content-end mb-4">
        <Col xs="auto">
          <Button className="pay-invoice-button" variant="outline-danger" onClick={handleGoBack}>
            <FaFastBackward /> Back
          </Button>
        </Col>
        <Col xs="auto">
          <Button className="pay-invoice-button" variant="outline-success">
            <SlPrinter /> Print
          </Button>
        </Col>
        <Col xs="auto">
          <Button className="pay-invoice-button" variant="outline-primary" onClick={handleDownloadPDF}>
            <FaDownload /> Download as PDF
          </Button>
        </Col>
      </Row>

      <div className="pay-invoice-content text-center">
        <img src="logo.png" alt="logo" className="pay-invoice-logo" />
        <p>Payslip<br/>
          Payslip for the Month August 2024<br />
          2024-08-21 to 2024-09-21
        </p>
      </div>

      <div className="pay-in-branch text-right">
        <p>Working Branch : Lahore</p>
      </div>

      <div>
        <Row>
          <Col md={6}><h6>EMP Username : your username</h6></Col>
          <Col md={6}><h6>EMP Name : your name</h6></Col>
        </Row>
        <Row>
          <Col md={6}><h6>Joining Date : mm/dd/yyyy</h6></Col>
          <Col md={6}><h6>Department : Information Technology</h6></Col>
        </Row>
        <Row>
          <Col md={6}><h6>Designation : Employee</h6></Col>
          <Col md={6}><h6>Available Leaves : 0</h6></Col>
        </Row>
      </div>

      <div className="pay-invoice-sub-containerrr">
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr className="pay-invoice-table-header">
                <th>Earnings</th>
                <th>Descriptions</th>
                <th>Amount</th>
                <th>Deduction Descriptions</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr className="table-left">
                <td><h6>Salary</h6></td>
                <td>Basic Salary</td>
                <td>27000</td>
                <td>Total Short hours : 00</td>
                <td>1000..</td>
              </tr>
              <tr className="table-left">
                <td><h6>Extratime</h6></td>
                <td>Total 0.0 Hours</td>
                <td>0</td>
                <td>PF of August 2024</td>
                <td>3000</td>
              </tr>
              <tr className="table-left">
                <td><h6>Public Holiday</h6></td>
                <td>Public Holiday hours : 0.0</td>
                <td>0</td>
                <td>Total Absent 0</td>
                <td>0</td>
              </tr>
              <tr className="table-left">
                <td><h6>Working Units</h6></td>
                <td>Total Working Units 0</td>
                <td>3000</td>
                <td>TAX DEDUCTION</td>
                <td>0</td>
              </tr>
              <tr className="table-left">
                <td colSpan="3" className="no-data">--</td>
                <td></td>
                <td></td>
              </tr>
              <tr className="table-left">
                <td><h6>Total</h6></td>
                <td>Total Earnings</td>
                <td>30000</td>
                <td>Total Deduction</td>
                <td>0000</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <Row>
        <Col md={6}><h6>NetPay</h6></Col>
        <Col md={6}><h6>In Words</h6></Col>
      </Row>
    </Container>
  );
}
